import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { CanActivateClassificacaoFaturamento } from './can-activate-classificacao-faturamento';
import { ClassificacaoFaturamentoComponent } from './classificacao-faturamento.component';
import { ClassificacaoFaturamentoFormComponent } from './form';


@NgModule({
    imports: [
        RouterModule.forChild([
            {
                path: '',
                canActivateChild: [CanActivateClassificacaoFaturamento],
                children: [
                    {path: '', component: ClassificacaoFaturamentoComponent},
                    {path: 'novo', component: ClassificacaoFaturamentoFormComponent},
                    {path: ':id', component: ClassificacaoFaturamentoFormComponent}
                ]
            }
        ])
    ],
    exports: [
        RouterModule
    ],
    providers: [
        CanActivateClassificacaoFaturamento
    ]
})
export class ClassificacaoFaturamentoRoutingModule { }
